
import { Box, Tabs, Tab, Typography } from "@mui/material";
// import HalaIndiaMarkLogo from "../../service_Listing/halaIndiaLogoMark";
// import NonDisclouserAggrement from "../nonDisclouser";
import React, { useState } from "react";

import ProductListPage from "./productListing";
// import ProductListing from "../../../Client_Portal/Certification/service_Listing/productListing";
import RawMaterialPage from "./rawMaterial";
// import RawMaterialListing from "../../../Client_Portal/Certification/service_Listing/rawMaterial";
import ProductSpecification from "./productSpecification";
import CoaPage from "./coa";
// import COA from "../../../Client_Portal/Certification/service_Listing/certificateOfAnalysis";
import PostAuditDeclaration from "../../../Client_Portal/Certification/service_Listing/postAudit";
import SupplierDeclaration from "../../../Client_Portal/Certification/service_Listing/SupplierDeclaration";
// import ProductSpecification from "../../../Client_Portal/Certification/service_Listing/productSpecification";
import PrimaryMenuListing from "./menuListing/PrimaryMenuListing";



// Company Detail Component
const CompanyDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Company Detail
    </Typography>
    <Typography>
      This is where the company details will be displayed.
    </Typography>
  </Box>
);

// Director Detail Component
const DirectorDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Director Detail
    </Typography>
    <Typography>
      This is where the director details will be displayed.
    </Typography>
  </Box>
);

// Main Tab Component
 function PrimaryServiceListing() {

const tabs=["Proudct Listing","Raw Material /Ingredient list","Product Specification","COA (Certificate of analysis)","Menu Listing"]
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box  sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
    
        height:"100%",
        my:2.5,
      
        
     
        // bgcolor:"#EDF2F9",
        // Custom scrollbar styles
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}>


       

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{
          borderBottom: 0,
          py:2,
          border:"2px solid red",
          my:0,
          py:0, 
          bgcolor:"#F9FAFC",
          width:"100%",
          borderColor: "divider",
          "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
        }}
      >


{
            tabs.map((label,index)=>{
                return <Tab label={label}  sx={{
                    textTransform: "none",
                    fontWeight: 500,
                    mx:0.5,
                    borderRadius: "4px",
                    border: activeTab === index ? "1px solid blue" : "divider",
                    borderColor: activeTab === index ? "primary.main" : "divider",
                    color: activeTab === index ? "primary.main" : "text.secondary",
                    backgroundColor: activeTab === index ? "white" : "transparent",
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                    padding: "px 16px",
                  }}/>
            })
        }          
      </Tabs>

      {/* Content Area */}
      <Box mt={2} sx={{boder:"2px solid green",
       width:"100%",height:"100%" }}>
        {activeTab === 0 && <ProductListPage />}
        {activeTab === 1 && <RawMaterialPage />}
        {activeTab === 2 && <ProductSpecification />}
        {activeTab === 3 && <CoaPage />}
        {activeTab === 4 && <PrimaryMenuListing />}
        {activeTab === 5 && <SupplierDeclaration />}
      
       
      </Box>
    </Box>
  );
}


export default PrimaryServiceListing;